export const SET_CURRENT_MODAL = `MODAL/SET_CURRENT_MODAL`;

export type CurrentModal =
  | 'CREATE_ORGANIZATION_INVITE'
  | 'EDIT_COMMISSION_RATE'
  | 'EDIT_HUBSPOT_ID'
  | 'EDIT_ORGANIZATION_NAME'
  | 'EDIT_INVENTORY_CONFIRMATION_DELAY'
  | 'EDIT_PRICING_FEE'
  | 'EDIT_POLICY_COVER_CAP'
  | 'RESET_PASSWORD_EMAIL'
  | '';

export function setCurrentModal(payload: CurrentModal) {
  return {
    type: SET_CURRENT_MODAL,
    payload,
  } as const;
}

export type ModalActionTypes = ReturnType<typeof setCurrentModal>;
